var generateStyle = function generateStyle(componentTheme) {
  return {
    userResponse: {
      width: '100%',
      boxSizing: 'border-box',
      padding: componentTheme.userResponsePadding,
      margin: "".concat(componentTheme.userResponseMargin, " 0"),
      fontSize: componentTheme.userResponseFontSize,
      fontFamily: componentTheme.userResponseFontFamily,
      whiteSpace: 'pre-wrap',
      wordWrap: 'break-word',
      overflow: 'auto'
    },
    gradingNotesWrapper: {
      marginTop: componentTheme.gradingNotesWrapperMargin,
      padding: componentTheme.gradingNotesWrapperPadding,
      backgroundColor: componentTheme.gradingNotesWrapperColor,
      borderRadius: componentTheme.gradingNotesWrapperBorderRadius,
      whiteSpace: 'pre-wrap',
      wordWrap: 'break-word'
    }
  };
};
export default generateStyle;